import React from 'react';

const UsersByCountry = (props) => {
	let _total = 0;

	props.countries.forEach((country) => {
		_total = _total + country.value;
	});

	return (
		<div className="location-list list-group">
			{props.countries
				.sort((a, b) => {
					if (a.value > b.value) {
						return -1;
					}
					if (a.value < b.value) {
						return 1;
					}

					return 0;
				})
				.map((country, index) => {
					const total =
						_total > 0 ? parseInt((country.value * 100) / _total, 10) : 0;

					if (props.limitCountries && index >= 5) {
						return null;
					}

					return (
						<div key={country.label} className="list-group-item">
							<span style={{ textTransform: 'capitalize' }}>
								{country.label}
							</span>
							<span>{country.value}</span>
							<div className="progress">
								<div
									className={`progress-bar wd-${
										Math.round(total / 5) * 5
									}p bg-purple`}
									role="progressbar"
									aria-valuenow={total}
									aria-valuemin="0"
									aria-valuemax="100"
								></div>
							</div>
						</div>
					);
				}, this)}
		</div>
	);
};

export default UsersByCountry;
